import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";

interface Health {
  status: string;
  version: string;
}

let loadedVersion: string | null = null;

export function useHealth() {
  const query = useQuery({
    queryKey: ["health"],
    queryFn: async () => {
      const data = await api<Health>("/health");
      loadedVersion ??= data.version;
      return data;
    },
    refetchInterval: 10_000,
  });

  const isStale =
    loadedVersion !== null &&
    query.data?.version !== undefined &&
    query.data.version !== loadedVersion;

  return { ...query, loadedVersion, isStale };
}
